import {
  fetchBanners,
  fetchMarketById,
  fetchPage,
  fetchPageLinks,
  localeToMarketCode,
  PageProps,
} from '@instabox/consumer-web-shared'
import { GetStaticPaths, GetStaticProps, NextPage } from 'next'
import { useRouter } from 'next/router'

import DeliveryReturn from '../../components/DeliveryReturn/DeliveryReturn'
import { ProductType } from '../../types/Returns'

const SLUG = 'returns'

const ReturnsPage: NextPage<PageProps> = ({ content }) => {
  const { query } = useRouter()

  const slug = query?.slug as string

  if (Object.keys(ProductType).includes(slug)) {
    return <DeliveryReturn content={content} />
  }
}

export default ReturnsPage

export const getStaticProps: GetStaticProps<PageProps> = async ({ locale, params }) => {
  const {
    data: { marketById },
  } = await fetchMarketById(localeToMarketCode(locale))

  const page = await fetchPage(locale, SLUG)
  const pageLinks = await fetchPageLinks(locale)
  const banners = await fetchBanners(locale, SLUG)

  const notFound = !Object.keys(ProductType).includes(params.slug.toString())

  return {
    props: {
      market: marketById,
      pageLinks,
      fullBleed: true,
      banners,
      slug: params?.slug as string,
      ...page,
    },
    notFound,
    revalidate: 60,
  }
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [...Object.keys(ProductType).map(type => ({ params: { slug: type } }))],
    fallback: 'blocking',
  }
}
